import { Card } from "antd";
import React from "react";
import DisableWrapper from "./DisableWrapper";

const SectionCard = (props) => {
  const { title, extraActionNode, children, maximumHeight, bodyStyle, disabled = false, flat = false } = props;
  return (
    <Card
    className={flat ? "card-container card-container--flat" : "card-container"}
      headStyle={{ border: "none", padding: "0px", margin: "0px", display:  title || extraActionNode ? 'block' : 'none'}}
      bodyStyle={{ padding: "0px", margin: flat ? "0px" : "16px 0px 0px", ...bodyStyle }}
      title={!_.isEmpty(title) &&
        <span
          style={{
            fontWeight: 600,
            color: "#111314",
            fontSize: "20px",
            lineHeight: "24px",
            fontFamily: "Poppins",
          }}
        >
          {title}
        </span>
      }
      // extra={extraActionNode}
      extra={<div style={{ minWidth: "120px", textAlign: "end" }}>{extraActionNode}</div>}
      style={{
        width: "100%",
        // flat: render as a transparent wrapper so a self-carding child (e.g.
        // AccountBlockV2) is the only visible card — avoids a card-in-a-card.
        padding: flat ? "0px" : "16px",
        gap: "8px",
        borderRadius: flat ? "0px" : "8px",
        boxShadow: flat ? "none" : "0px 1px 1px 0px rgba(0, 0, 0, 0.24)",
        background: flat ? "transparent" : undefined,
        transition: "box-shadow 0.3s ease",
        height: maximumHeight ? maximumHeight : 'auto',
      }}
      bordered={false}
    >
      <DisableWrapper disabled={disabled}>
      {children}
      </DisableWrapper>
    </Card>
  );
};

export default SectionCard;
